import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers.js';
// import logger from 'redux-logger';

// List of middleware to be created with the store to be used in actions.
const middleware = [thunk];
// const middleware = [thunk, logger];

const rootReducerWithLogout = (state, action) => {
	if (action.type === 'LOG_OUT') {
		state = undefined;

	}
	return rootReducer(state, action);
};

// For redux devtools.
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create store with rootReducer for reducers/index.js.
const store = createStore(
	rootReducerWithLogout,
	composeEnhancer(applyMiddleware(...middleware))
);

export default store;
